// extracted by mini-css-extract-plugin
export default {"pushDrawerDetail":"mfr-H348wAwU","pushDrawerPortal":"mfr-MyYVYUTv"};